import { Box, Grid } from "@mui/material"
import { Dialog, Text } from "src/shared"

interface IGiftExchangeSuccessDialogPros {
  open?: boolean
  onClose: () => void
}

const GiftExchangeSuccessDialog = ({
  open = false,
  onClose,
}: IGiftExchangeSuccessDialogPros) => {
  const onDialogClose = () => onClose()

  return (
    <Dialog disablePortal open={open} onClose={onDialogClose}>
      <Grid rowGap={1} container alignItems="center" direction="column">
        <Text
          fontWeight={700}
          fontSize={24}
          lineHeight="31.65px"
          width={269}
          textTransform="unset"
          sx={theme => ({
            color: theme.palette.secondary.main,
          })}
          textAlign="center"
        >
          Chúc mừng bạn đã nhận được phần quà
        </Text>
        <Box>
          <img src="/assets/images/gift2.png" alt="gift1" />
        </Box>
        <Box textAlign="center">
          <Text
            fontSize={16}
            mt={1}
            sx={() => ({
              lineHeight: "21.1px",
            })}
          >
            Tên quà tặng
          </Text>
          <Text
            fontSize={16}
            sx={() => ({
              lineHeight: "21.1px",
              "& > span": {
                fontWeight: "bold",
              },
            })}
          >
            Trị giá <span>100.000đ</span>
          </Text>
        </Box>
      </Grid>
    </Dialog>
  )
}

export default GiftExchangeSuccessDialog
